import { type IAppState } from './types';

export const selectAppSettings = (state: IAppState) => state.userSettings.APP_SETTINGS;
